import React from 'react';

const AdminDashboardPage = () => {
    return (
        <div>
            <h1>Kontrol Paneline Hoş Geldiniz</h1>
            <p>Bu panel üzerinden web sitesinin içeriğini yönetebilirsiniz.</p>
        </div>
    );
};

export default AdminDashboardPage;